const getUrlParams = function () {
  const params = {}
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (_str, key, value) {
    params[key] = value
  })
  return params
}
const cmd = {
  file: 'sc-file',
  data: 'sc-data',
  manage: 'sc-manage',
  page: 'sc-page-manage',
  menu: 'sc-menu-manage',
  service: 'sc-service',
  coupon: 'sc-coupon',
  localinfo: 'sc-local-info',
  flightinfo: 'sc-flight-info',
  createplaceid: 'sc-create-placeid',
  amenity: 'sc-amenity'
}
const func = {
  gvf: 'gvf',
  file: 'file',
  getuserconfig: 'get-user-ci-config',
  updateuserconfig: 'update-user-ci-config',
  getmyaccount: 'get-my-account',
  getallusers: 'get-all-users',
  updateuserrole: 'update-user-role',
  updateusernickname: 'update-user-nickname',
  updateuserpw: 'update-user-pw',
  createpage: 'create-page',
  getpage: 'get-page',
  getallpages: 'get-all-pages',
  updatepage: 'update-page',
  deletepage: 'delete-page',
  createmenu: 'create-menu',
  getmenu: 'get-menu',
  getallmenus: 'get-all-menus',
  updatemenu: 'update-menu',
  deletemenu: 'delete-menu',
  getsystemcode: 'get-system-code',
  getcode: 'get-cat-code',
  getrequestcode: 'get-request-codes',
  setcode: 'set-cat-code',
  createcoupon: 'create-coupon',
  updatecoupon: 'update-coupon',
  deletecoupon: 'delete-coupon',
  getallcoupon: 'get-all-coupon',
  getcouponcategory: 'get-coupon-category',
  setcouponcategory: 'set-coupon-category',
  getlocalinfocategory: 'get-local-info-category',
  updatelocalinfovisible: 'update-local-info-visible',
  updatelocalinforecommend: 'update-local-info-recommend',
  createplaceid: 'create-placeid',
  getamenity: 'get-master-amenity',
  getairport: 'get-airport'
}

const API = {
  KEYHEADER: {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.VUE_APP_AUTH_API_KEY
    }
  },
  BASE_URL: getUrlParams().debug && getUrlParams().debug === '1'
    ? process.env.VUE_APP_API_ORIGIN_DEBUG
    : window.location.origin.includes('localhost') ? 'https://edit.istay.io' : window.location.origin,
  GET_MY_ACCOUNT_PARMAS: {
    cmd: cmd.manage,
    func: func.getmyaccount
  },
  // amenity
  GET_AMENITY: {
    cmd: cmd.amenity,
    func: func.getamenity
  },
  // user config (admin only / agreement, site config...)
  GET_USER_CONFIG: {
    cmd: cmd.manage,
    func: func.getuserconfig
  },
  UPDATE_USER_CONFIG: {
    cmd: cmd.manage,
    func: func.updateuserconfig
  },
  // manage data (admin only)
  GET_ALL_USER_PARMAS: {
    cmd: cmd.manage,
    func: func.getallusers
  },
  UPDATE_USER_ROLE_PARAMS: {
    cmd: cmd.manage,
    func: func.updateuserrole
  },
  UPDATE_USER_NICKNAME_PARAMS: {
    cmd: cmd.manage,
    func: func.updateusernickname
  },
  UPDATE_USER_PW_PARAMS: {
    cmd: cmd.manage,
    func: func.updateuserpw
  },
  // page data
  CREATE_PAGE_PARAMS: {
    cmd: cmd.page,
    func: func.createpage
  },
  GET_PAGE_PARAMS: {
    cmd: cmd.page,
    func: func.getpage
  },
  GET_ALL_PAGE_PARAMS: {
    cmd: cmd.page,
    func: func.getallpages
  },
  UPDATE_PAGE_PARAMS: {
    cmd: cmd.page,
    func: func.updatepage
  },
  DELETE_PAGE_PARAMS: {
    cmd: cmd.page,
    func: func.deletepage
  },
  // menu data
  CREATE_MENU_PARAMS: {
    cmd: cmd.menu,
    func: func.createmenu
  },
  GET_MENU_PARAMS: {
    cmd: cmd.menu,
    func: func.getmenu
  },
  GET_ALL_MENU_PARAMS: {
    cmd: cmd.menu,
    func: func.getallmenus
  },
  UPDATE_MENU_PARAMS: {
    cmd: cmd.menu,
    func: func.updatemenu
  },
  DELETE_MENU_PARAMS: {
    cmd: cmd.menu,
    func: func.deletemenu
  },
  // with .gvf files
  GET_GVF_PARAMS: {
    cmd: cmd.file,
    method: 'get',
    func: func.gvf
  },
  SET_GVF_PARAMS: {
    cmd: cmd.file,
    method: 'set',
    func: func.gvf
  },
  DEL_GVF_PARAMS: {
    cmd: cmd.file,
    method: 'delete',
    func: func.gvf
  },
  // with binary files (image, webfont, etc...)
  SET_FILE_PARAMS: {
    cmd: cmd.file,
    method: 'set',
    func: func.gvf
  },
  DEL_FILE_PARAMS: {
    cmd: cmd.file,
    method: 'delete',
    func: func.file
  },
  // with service data (category using submit @page/submit)
  GET_SYSTEM_PARAMS: {
    cmd: cmd.service,
    func: func.getsystemcode
  },
  GET_SERVICE_PARAMS: {
    cmd: cmd.service,
    func: func.getcode
  },
  GET_REQUEST_PARAMS: {
    cmd: cmd.service,
    func: func.getrequestcode
  },
  SET_SERVICE_PARAMS: {
    cmd: cmd.service,
    func: func.setcode
  },
  // with coupon data (create, update, delete / coupon list, coupon item, coupon category)
  CREATE_COUPON_PARAMS: {
    cmd: cmd.coupon,
    func: func.createcoupon
  },
  UPDATE_COUPON_PARAMS: {
    cmd: cmd.coupon,
    func: func.updatecoupon
  },
  DEL_COUPON_PARAMS: {
    cmd: cmd.coupon,
    func: func.deletecoupon
  },
  GET_ALL_COUPON_PARAMS: {
    cmd: cmd.coupon,
    func: func.getallcoupon
  },
  GET_COUPON_CATEGORY_PARAMS: {
    cmd: cmd.coupon,
    func: func.getcouponcategory
  },
  SET_COUPON_CATEGORY_PARAMS: {
    cmd: cmd.coupon,
    func: func.setcouponcategory
  },
  // localinfo
  GET_LOCAL_INFO_CATEGORY: {
    cmd: cmd.localinfo,
    func: func.getlocalinfocategory
  },
  UPDATE_LOCAL_INFO_VISIBLE: {
    cmd: cmd.localinfo,
    func: func.updatelocalinfovisible
  },
  UPDATE_LOCAL_INFO_RECOMMEND: {
    cmd: cmd.localinfo,
    func: func.updatelocalinforecommend
  },
  CREATE_PLACEID: {
    cmd: cmd.createplaceid,
    func: func.createplaceid
  },
  // flightinfo
  GET_FLIGHT_INFO_AIRPORT: {
    cmd: cmd.flightinfo,
    func: func.getairport
  }
}
export default API
